import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

import { AgGridModule } from 'ag-grid-angular';



@Component({
    templateUrl: 'toast-message-dialog.html',
    standalone: false
})
export class ToastMessageDialog {

  toastMessage = null;

  constructor() {


    }

}





@Component({
    selector: 'pick-saved-report-dialog',
    templateUrl: 'pick-saved-report-dialog.html',
    standalone: true,
    imports: [
      AgGridModule
    ]
})
export class GenericListOfSavedReportsDialog {

  defaultColDef = { resizable: true,
                    sortable: true,
                    filter: true
                  };

  colSavedReportNames = { colId: 'nameOfSavedReport',
                          headerName: 'Saved Report Name',
                          field: 'savedViewName',
                          width: 200, sortable: true};

  listOfSavedReports = [];

  gridApi = null;

  toastMessage = null;

  contractColumns = [
    {headerName: 'Report Name', field: 'savedViewName', width: 125 }
  ];

  constructor(
    public dialogRef: MatDialogRef<GenericListOfSavedReportsDialog>,
    @Inject(MAT_DIALOG_DATA) public data) {

      this.listOfSavedReports = data.savedReports;

      console.log('saved reports data: ', data);
      console.log('list of saved reports: ', this.listOfSavedReports);
    }


  onCellClicked(event) {
    console.log('event data: ', event.value);
    this.dialogRef.close(event.value);
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }
}




export class ViewInteraction {

    // contractManagerService = new ContractManagerService();

    saveNamedViewNow(nameOfSavedView, entity, columnState, userId) {

      }  // end of save named view

}

@Component({
    selector: 'saved-view-snack',
    templateUrl: '../toolbar-utilities/saved-view-snack.html',
    styles: [`
      .save-view {
        color: hotpink;
      }`
    ],
    standalone: false
})
  

  export class GenericSavedViewComponent {}
